
import ProfilePicWithDetails from 'Components/Client/Cases/CaseDetails/ProfilePicWithDetails'
import { DEFAULTAVATAR, getAllCaseDetailsApi } from 'Constants';
import { Context } from 'Context/Context';
import useIsMobile from 'Hooks/useIsMobile';
import React, { useContext, useEffect, useState } from 'react'
import ReactModal from 'react-modal'
import { Link, useNavigate } from 'react-router-dom';

function CompleteUserDetails({uploadNew, onClose, user, userId}) {
    const [currentTab, setCurrentTab] = useState(1);
    const [caseDets, setCaseDets] = useState([]);
    const [oldUser, setOldUser] = useState(null);
    const isMobile = useIsMobile();
    const {makeApiCallFunc} = useContext(Context);

    const profData = {
        "First name" : "firstName",
        "Last name" : "lastName",
        "Email" : "email",
        "Designation" : "legalType",
        "Firm Name" : "company",
        "Phone number" : "phoneNumber",
        "Experience" : "experience",
        "Law Firm URL" : "lawFirmLink",
        "LinkedIn" : "linkedin"  ,
        "Login Count" : "totalLoginCount",
    }
    const attorneyProfData = {
        "First name" : "firstName",
        "Last name" : "lastName",
        "Email" : "email",
        "Law Firm URL" : "lawFirmLink",
        "LinkedIn" : "linkedin" 
    }
    const caseProfData = {
        "Requested" : "requested",
        "Denied" : "denied",
        "Approved" : "approved",
        "Conflict cleared" : "noConflict",
        "Requested to close" : "reqToClose" ,
        "Closed" : "closed"
    }
    const navigate = useNavigate();
    useEffect(()=>{
        makeApiCallFunc(getAllCaseDetailsApi+"/"+user.id,
        null,
        ({data}) => 
        {
            setCaseDets(data.caseDets);
            setOldUser({"profile": data.oldProfile.profile, "cases": data.oldCases});
            //const closedCount = getCountOfStatus("closed", data);
          //  setCaseDets({...data, "closedCasesCount" : })

        },
        (data) => console.log(data),
        false,true
        )
    },[])
    const getCountOfStatus = (obj, label) => {
        let count = 0;
        obj.map((cas) => { 
            if(cas.caseStatus === label)
            {
                return count++ ;
            } 
        })
        return count;
    }
    const getLabel = (label) => {
        return Object.keys(caseProfData).map((i)=>{if(caseProfData[i] === label)
            {
                return i;
            }
        }
            )
    }
  return (
    <ReactModal
    shouldCloseOnEsc = {true}
    shouldCloseOnOverlayClick = {true}
    onRequestClose={onClose}
    isOpen = {uploadNew}
    style={{
        overlay: {
          zIndex: 30
           
        },
        content: {
            height: isMobile ? '400px' : '420px',
            width: isMobile ? '350px':'auto',
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
        }
      }}
    >   
            
            <div className='w-full font-bold flex items-center justify-center mt-4'>
                {user?.isUserAssistant &&
                    <div className={' p-2 text-xs cursor-pointer relative w-full text-center ' +(currentTab === 0 ? "bg-ivory border border-tan border-b-0 text-tan " : "  bg-white border-b-tan border")} onClick={()=>setCurrentTab(0)}>Attorney Details
                </div>
                }
            <div className={'p-2 relative text-xs cursor-pointer w-full text-center'+(currentTab === 1 ? " bg-ivory border border-tan border-b-0 text-tan " : "  bg-white border-b-tan border")} onClick={() =>setCurrentTab(1)}>{user?.legalType}
            </div>
            <div className={'p-2 relative text-xs cursor-pointer w-full text-center'+(currentTab === 2 ? " bg-ivory border border-tan border-b-0 text-tan " : "  bg-white border-b-tan border")} onClick={() =>setCurrentTab(2)}>Case details
            </div>
            {oldUser?.profile && <><div className={'p-2 relative text-xs cursor-pointer w-full text-center'+(currentTab === 3 ? " bg-ivory border border-tan border-b-0 text-xs text-tan " : "  bg-white border-b-tan border")} onClick={() =>setCurrentTab(3)}>Previous user profile
            </div>
            <div className={'p-2 relative cursor-pointer text-xs w-full text-center'+(currentTab === 4 ? " bg-ivory border border-tan border-b-0 text-tan " : "  bg-white border-b-tan border")} onClick={() =>setCurrentTab(4)}>Previous case details
            </div></>
            }

            </div>
        <div className='flex items-center flex-col text-sm'>
            {
                currentTab === 1 ? 
                <div className={(currentTab === 1 ? ' bg-ivory p-4 w-full border-tan border border-t-0 border-1 ' : '')  + ' flex lg:flex-row flex-col pt-4'}>
               { user.verified ?
                <div className='w-full mr-4 '>
                <ProfilePicWithDetails currentProf={user}/>
                </div>
                :
                <div className='w-full mr-4 '>
                    <img 
                    className='flex w-20 h-20 border ring-2 rounded-full ring-gray-400 '
                    
                    src={DEFAULTAVATAR} alt="Preview" />
                </div>
                    }
                    <div className='flex w-full flex-col justify-between'>
                        {Object.entries(profData).map(([label, value], index) => {
                        return  <div className='mr-5 flex items-center w-[370px] mb-2'>
                            <label className="w-[140px]">
                        {label}
                            </label>
                            <div>
                            {user?.[value] ? 
                            (label.toLowerCase().includes("link") ? <a target="_blank" rel="noopener noreferrer" className="text-tan underline" href={"https://"+user?.[value]}>{user?.[value]}</a> :
                            user?.[value]) : '--'} </div>
                            </div>
                        })}
                    </div>
                      
                </div>
                :
                currentTab === 0 ? 
                user?.isUserAssistant &&
                    <div className='flex w-full justify-between border bg-ivory p-4 border-tan border border-t-0'  >
                <div className='w-full mr-4'>
                    <ProfilePicWithDetails currentProf={user?.attorney}/>
                </div>
                    <div className='flex w-full flex-col justify-between'>
                        {Object.entries(attorneyProfData).map(([label, value], index) => {
                        return  <div className='mr-5 flex items-center  mb-2 w-[370px]'>
                            <label className="w-[140px]">
                        {label}
                            </label>
                            <div>
                            {user?.attorney?.[value] ? 
                            (label.toLowerCase().includes("link") ? <a target="_blank" rel="noopener noreferrer" className="text-tan underline" href={"https://"+user?.attorney?.[value]}>{user?.attorney?.[value]}</a> :
                            user?.attorney?.[value]) : '--'} </div>
                        </div>
                        })}
                    </div>         
                </div> 
                :
                currentTab === 2 ?
                <div className=' w-full border flex flex-col items-center bg-ivory p-4 border-tan border border-t-0'>
                    <div className='bg-tan mb-3 flex justify-center lg:w-max rounded text-sm px-2 p-1 text-white '>Total requests sent out by the professional : {caseDets.length}</div>
                    <div className='flex w-full justify-between  '  >
                    <div className='flex w-full justify-center lg:flex-row flex-col'>
                            
                            <div>
                        {Object.entries(caseProfData).map(([label, value], index) => {
                            return  <div className='mr-5 flex items-center bg-[rgba(138,98,49,.08)] p-1 text-xs rounded shadow-sm border  mb-2 mt-2'>
                                <label className="w-[140px]">
                            {label}
                                </label>
                                <div className=''>
                                {getCountOfStatus(caseDets, value)}
                                </div>
                            </div>
                            })}
                            </div>
                            {caseDets.length !== 0 &&
                             <table class="table-auto w-[520]  border p-2 text-xs overflow-y-scroll block h-[200px]" >
                            <thead className='border w-screen'>
                                <tr className='text-tan'>
                                <th className='text-left p-2 w-[100px] p-2 '>Status</th>

                                <th className='text-left w-[150px] p-2'>Client</th>
                                <th className='text-left w-[150px] p-2'>AdverseParty</th>
                                </tr>
                            </thead>
                            <tbody className='p-2'>
                                    {caseDets.map((cas) => {
                                            return <>
                                            {cas?.caseId &&
                                            <tr className=' cursor-pointer' onClick={()=> navigate("/admin/caseDetails/"+cas.caseId._id)}>
                                            <td className='p-1'>{getLabel(cas.caseStatus)}</td>
                                            <td className='p-1'>{cas?.caseId?.isOwnerAnonymous ? "Anonymous" : cas.caseId.firstName + "" +cas.caseId.lastName}</td>
                                            <td className='p-1'>{cas?.caseId?.adversePartyName}</td>
                                            </tr>
                                                }
                                            </>
                                    })}
                            </tbody>
                        </table>
                        }  
                        </div>         
                    </div>
                </div>
                :
                currentTab === 3 ?
                oldUser?.profile &&
                oldUser?.profile?.map((profileEle, key) => {
                    return <div className={(currentTab === 3 ? ' bg-ivory p-4 w-full border-tan border border-t-0 border-1 ' : '')  + ' flex pt-4'}>
                    { profileEle.verified ?
                    <div className='w-full mr-4 '>
                    <ProfilePicWithDetails currentProf={profileEle}/>
                    </div>
                    :
                    <div className='w-full mr-4 '>
                        <img 
                        className='flex w-20 h-20 border ring-2 rounded-full ring-gray-400 '
                        
                        src={DEFAULTAVATAR} alt="Preview" />
                    </div>
                        }
                    <div className='flex w-full flex-col justify-between'>
                        {Object.entries(profData).map(([label, value], index) => {
                        return  <div className='mr-5 flex items-center w-[370px] mb-2'>
                            <label className="w-[140px]">
                        {label}
                            </label>
                            <div>
                            {profileEle?.[value] ? 
                            (label.toLowerCase().includes("link") ? <a target="_blank" rel="noopener noreferrer" className="text-tan underline" href={"https://"+profileEle?.[value]}>{profileEle?.[value]}</a> :
                            profileEle?.[value]) : '--'} </div>
                            </div>
                        })}
                    </div>
                </div>
                })
                    
                 :
                currentTab === 4 ?
                oldUser.cases &&
                oldUser.cases.map((cas) => {
                    return <div className=' w-full border flex flex-col items-center bg-ivory p-4 border-tan border border-t-0'>
                    <div className='bg-tan mb-3 flex justify-center w-max rounded text-sm px-2 p-1 text-white '>Total requests sent out by the professional : {cas?.length}</div>
                    <div className='flex w-full justify-between '  >
                    <div className='flex w-full justify-center'>
                            
                            <div>
                        {Object.entries(caseProfData).map(([label, value], index) => {
                            return  <div className='mr-5 flex items-center bg-[rgba(138,98,49,.08)] p-1 text-xs rounded shadow-sm border  mb-2 mt-2'>
                                <label className="w-[140px]">
                                    {label}
                                </label>
                                <div className=''>
                                {getCountOfStatus(cas, value)}
                                </div>
                            </div>
                            })}
                            </div>
                            {cas?.length !== 0 &&
                                <table class="table-auto w-[520]  border p-2 text-xs overflow-y-scroll block h-[200px]" >
                            <thead className='border w-screen'>
                                <tr className='text-tan'>
                                <th className='text-left p-2 w-[100px] p-2 '>Status</th>

                                <th className='text-left w-[150px] p-2'>Client</th>
                                <th className='text-left w-[150px] p-2'>AdverseParty</th>
                                </tr>
                            </thead>
                            <tbody className='p-2'>
                                    {cas?.map((cas1) => {
                                            return <>
                                            {cas1?.caseId &&
                                            <tr className=' cursor-pointer' onClick={()=> navigate("/admin/caseDetails/"+cas1.caseId._id)}>
                                            <td className='p-1'>{getLabel(cas1.caseStatus)}</td>
                                            <td className='p-1'>{cas1?.caseId?.isOwnerAnonymous ? "Anonymous" : cas1.caseId.firstName + "" +cas1.caseId.lastName}</td>
                                            <td className='p-1'>{cas1?.caseId?.adversePartyName}</td>
                                            </tr>
                                                }
                                            </>
                                    })}
                            </tbody>
                        </table>
                        }  
                        </div>         
                    </div>
                    </div>
                })
                :
                <></>
            }
         </div>
    </ReactModal>
  )
}

export default CompleteUserDetails